import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { sha512 } from 'js-sha512';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function decodeBase64(base64String: any) {
  const decoded = Buffer.from(base64String, 'base64').toString('utf8');
  return decoded;
}

export function encodeString(string: any) {
  const hash = sha512.create();
  hash.update(string);

  return hash.hex();
}

export function capitalizeString(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}